(function () {
  var root = document.documentElement;
  var frame = null;
  var lastValues = '';

  function getRootFontSize() {
    var size = parseFloat(window.getComputedStyle(root).fontSize);

    return Number.isFinite(size) && size > 0 ? size : 16;
  }

  function toRem(value, rootFontSize) {
    var remValue = (Math.max(0, value) / rootFontSize).toFixed(4).replace(/\.?0+$/, '');

    return (remValue || '0') + 'rem';
  }

  function getMeasurements() {
    var visualViewport = window.visualViewport;
    var layoutHeight = window.innerHeight || root.clientHeight || 0;
    var rootFontSize = getRootFontSize();
    var viewportHeight = visualViewport && visualViewport.height ? visualViewport.height : layoutHeight;
    var viewportOffsetTop = visualViewport && visualViewport.offsetTop ? visualViewport.offsetTop : 0;
    var viewportBottomOffset = Math.max(0, layoutHeight - viewportHeight - viewportOffsetTop);

    return {
      height: viewportHeight,
      topOffset: viewportOffsetTop,
      bottomOffset: viewportBottomOffset,
      heightRem: toRem(viewportHeight, rootFontSize),
      topOffsetRem: toRem(viewportOffsetTop, rootFontSize),
      bottomOffsetRem: toRem(viewportBottomOffset, rootFontSize)
    };
  }

  function applyMeasurements() {
    frame = null;

    var measurements = getMeasurements();
    var nextValues = [
      measurements.heightRem,
      measurements.topOffsetRem,
      measurements.bottomOffsetRem
    ].join('|');

    if (nextValues === lastValues) {
      return;
    }

    lastValues = nextValues;
    root.style.setProperty('--lx-viewport-height', measurements.heightRem);
    root.style.setProperty('--lx-viewport-top-offset', measurements.topOffsetRem);
    root.style.setProperty('--lx-viewport-bottom-offset', measurements.bottomOffsetRem);
    window.dispatchEvent(new CustomEvent('lumenearz:viewportchange', { detail: measurements }));
  }

  function scheduleUpdate() {
    if (frame) {
      return;
    }

    frame = window.requestAnimationFrame(applyMeasurements);
  }

  window.lumenearzViewport = {
    getMeasurements: getMeasurements,
    update: scheduleUpdate
  };

  applyMeasurements();
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('orientationchange', scheduleUpdate, { passive: true });
  window.addEventListener('pageshow', scheduleUpdate, { passive: true });

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleUpdate, { passive: true });
    window.visualViewport.addEventListener('scroll', scheduleUpdate, { passive: true });
  }
})();
